export const Legend = ({
  data,
  hoverIndex,
  setHoverIndex,
  direction,
  COLORS = [],
}) => {
  const isBottom = direction === "bottom";

  return (
    <div
      className={
        isBottom
          ? "grid gap-x-4 gap-y-2 w-full max-w-md"
          : "flex flex-col gap-3 min-w-[220px]"
      }
    >
      {data.map((item, idx) => {
        const active = hoverIndex === null || hoverIndex === idx;

        return (
          <div
            key={idx}
            onMouseEnter={() => setHoverIndex(idx)}
            onMouseLeave={() => setHoverIndex(null)}
            className={`flex items-center justify-between gap-3 cursor-pointer transition-opacity ${
              active ? "opacity-100" : "opacity-40"
            }`}
          >
            <div className="flex items-center gap-2 min-w-0 flex-1">
              <span
                className="w-3 h-3 rounded-full"
                style={{ backgroundColor: COLORS[idx % COLORS?.length] }}
              />
              <span className="text-sm text-gray-700 break-words">
                {item.label}
                <span className="text-gray-500 ml-1">({item.percent}%)</span>
              </span>
            </div>

            <span className="text-sm font-medium text-gray-900 tabular-nums shrink-0">
              {new Intl.NumberFormat("vi-VN").format(item.value)}
            </span>
          </div>
        );
      })}
    </div>
  );
};
